export default {
  reward_title: "邀请奖励",
  reward_desc_dynamic: "每成功邀请一位朋友注册，您将获得 {0} 次计算奖励",
  invite_friend: "邀请朋友",
  friend_email: "朋友邮箱",
  email_placeholder: "请输入您朋友的邮箱",
  send_invite: "发送邀请",
  invite_instructions: "邀请说明",
  email_invitation_validity_dynamic: "邮件邀请有效期为 {0} 天",
  link_invitation_permanent: "链接邀请永久有效",
  instruction_1_dynamic: "每成功邀请一次，您和您的朋友都将获得 {0} 次计算积分",
  instruction_2: "奖励将在您的朋友接受邀请并成功注册后自动发放",
  instruction_3: "奖励积分可用于碳排放计算，有效期根据您的订阅套餐而定",
  invite_stats: "邀请统计",
  total_invites: "总邀请数",
  accepted_invites: "已接受邀请",
  reward_credits: "奖励积分",
  invite_link: "个人邀请链接",
  reward_rules: "奖励规则",
  reward_rule_1_dynamic: "每成功邀请一次，您将获得 {0} 次计算积分奖励",
  reward_rule_2: "奖励积分将自动添加到您的账户中，可用于碳排放计算",
  reward_rule_3: "如发现作弊行为，我们保留取消奖励并封禁账户的权利",
  email_required: "请输入邮箱地址",
  email_invalid: "邮箱格式无效",
  invite_sent: "邀请已发送",
  send_failed: "发送邀请失败",
  fetch_failed: "获取邀请信息失败",
  copy_success: "复制成功",
  email_invitation: "邮件邀请",
  link_invitation: "链接邀请",
  status_pending: "待处理",
  status_accepted: "已接受",
  status_expired: "已过期",
  reward_issued: "已发放",
  pending: "待处理",
  reward_pending_tip: "奖励将在您的朋友完成首次计算后发放",
  expiring_soon: "即将过期",
  no_invitations: "暂无邀请记录",
  invitee_id: "被邀请人ID",
  type: "邀请类型",
  email: "邮箱",
  status: "状态",
  reward_status: "奖励状态",
  invite_time: "邀请时间",
  expire_time: "过期时间",
  my_invitations: "我的邀请",
  invite_created_title: "邀请链接",
  invite_created_desc: "邮件发送失败。请手动将以下链接发送给您的朋友：",
  total_invitations: "共 {0} 条记录",
  search_invitations: "搜索邀请...",
  confirm: "确认",
};
